import { CLIPPER_SCALE } from '../core/config';
import { ringBounds } from './polygon';
import type { PolygonWithHoles } from './types';

/** Retain whole polygons and their order, including any bounds that can meet after quantization. */
export function clipCandidates(
  subjects: readonly PolygonWithHoles[],
  polygons: readonly PolygonWithHoles[]
): readonly PolygonWithHoles[] {
  const boxes = subjects.map((p) => ringBounds(p.outer));
  const margin = 1 / CLIPPER_SCALE;
  return polygons.filter((p) => {
    const b = ringBounds(p.outer);
    return boxes.some(
      (a) =>
        b.minX <= a.maxX + margin &&
        b.maxX >= a.minX - margin &&
        b.minY <= a.maxY + margin &&
        b.maxY >= a.minY - margin
    );
  });
}
